import React from 'react';
import { Database } from 'lucide-react';
import { usePageContext } from '@/contexts/PageContext';
import { useStorageInfo } from './hooks/useStorageInfo';

export const StorageInfo: React.FC = () => {
  const { formattedUsed, usedPercentage } = useStorageInfo();
  const { subscription } = usePageContext();
  const totalStorageGB = subscription?.totalAssetSpaceGB || 0;

  return (
    <div className="bg-white p-4 sm:p-6 rounded-xl mb-4 sm:mb-6">
      <div className="flex items-center mb-2">
        <Database className="w-5 h-5 text-primary-800 mr-2" />
        <h3 className="text-lg font-semibold text-gray-700">Storage Usage</h3>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5 mb-2">
        <div
          className="bg-primary-950 h-2.5 rounded-full transition-all duration-500 ease-in-out"
          style={{ width: `${usedPercentage}%` }}
        ></div>
      </div>
      <p className="text-sm text-gray-600">
        {formattedUsed} / {totalStorageGB.toFixed(2)} GB
      </p>
    </div>
  );
};
